import { render, staticRenderFns } from "./WebsiteGoodsCategoryEdit.vue?vue&type=template&id=6dc49da3&"
import script from "./WebsiteGoodsCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./WebsiteGoodsCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports